module.exports = __webpack_public_path__ + "img/IO-website-transparant-300x175.915a9a7f.png";